// ErrorMessage.js
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import styles from './TraderDashboard.module.css';

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  
  return (
    <div className={styles.errorMessage}>
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <span>{message}</span>
    </div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;